import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-962">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-963">
        <SparkleEffect count={80} data-id="element-964" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-965">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-966">
            Trippin' Through <span className="text-cta-500" data-id="element-967">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-968">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-969" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-970">
        <SparkleEffect count={60} data-id="element-971" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-972">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-973">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-974">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-975">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-976">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-977">
            {/* NEW: Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-978">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-979">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-980">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-981">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-982">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-983">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-984" />
              </Link>
            </motion.div>

            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-985">
              <div className="text-3xl mb-4" data-id="element-986">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-987">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-988">
                <li className="flex items-start gap-2" data-id="element-989">
                  <span className="text-cta-500 mt-1" data-id="element-990">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-991">
                  <span className="text-cta-500 mt-1" data-id="element-992">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-993">
                  <span className="text-cta-500 mt-1" data-id="element-994">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-995">
                  <span className="text-cta-500 mt-1" data-id="element-996">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-997">
                  <span className="text-cta-500 mt-1" data-id="element-998">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-999">
              <div className="text-3xl mb-4" data-id="element-1000">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1001">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1002">
                <li className="flex items-start gap-2" data-id="element-1003">
                  <span className="text-cta-500 mt-1" data-id="element-1004">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-1005">
                  <span className="text-cta-500 mt-1" data-id="element-1006">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-1007">
                  <span className="text-cta-500 mt-1" data-id="element-1008">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-1009">
              <div className="text-3xl mb-4" data-id="element-1010">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1011">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1012">
                <li className="flex items-start gap-2" data-id="element-1013">
                  <span className="text-cta-500 mt-1" data-id="element-1014">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-1015">
                  <span className="text-cta-500 mt-1" data-id="element-1016">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-1017">
                  <span className="text-cta-500 mt-1" data-id="element-1018">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* EMERGENCY CONTACTS */}
      <section className="py-16 bg-gradient-to-br from-plum-900 via-plum-800 to-plum-900 relative overflow-hidden" data-id="element-1019">
        <SparkleEffect count={40} data-id="element-1020" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-1021">
          <GlitterHeart size={48} variant="light" className="mx-auto mb-6" data-id="element-1022" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1023">
            If You're in Crisis
          </h2>
          <p className="text-plum-200 text-lg mb-10 font-medium" data-id="element-1024">
            Please don't wait. Reach out to someone who can help right now.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-1025">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20" data-id="element-1026">
              <h3 className="font-bold text-white text-xl mb-2" data-id="element-1027">
                Crisis Text Line
              </h3>
              <p className="text-plum-200 mb-4 font-medium" data-id="element-1028">
                Text HOME to 741741 to connect with a crisis counselor 24/7.
              </p>
              <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-cta-400 hover:text-cta-300 font-bold transition-colors" data-id="element-1029">
                Visit Website <ArrowRightIcon className="w-4 h-4" data-id="element-1030" />
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20" data-id="element-1031">
              <h3 className="font-bold text-white text-xl mb-2" data-id="element-1032">
                Suicide & Crisis Lifeline
              </h3>
              <p className="text-plum-200 mb-4 font-medium" data-id="element-1033">
                Call or text 988. Available 24/7, free, and confidential.
              </p>
              <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-cta-400 hover:text-cta-300 font-bold transition-colors" data-id="element-1034">
                Visit Website <ArrowRightIcon className="w-4 h-4" data-id="element-1035" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}